import { useState } from "react";
import { GeocoderClient, IPlacePredictionsRequestViewModel, PlacePredictionsRequestViewModel } from "./API/API";
import { useApiClient } from "./API/useApiClient";

let sessionToken = Guid && Guid.NewGuid();

class PlaceGeocoder {
   #geocoderClient: GeocoderClient;
   constructor(geocoderClient: GeocoderClient) {
      this.#geocoderClient = geocoderClient;
   }
   async getPlacePredictions(request: Pick<IPlacePredictionsRequestViewModel, "input"> & Partial<Omit<IPlacePredictionsRequestViewModel, "input">>) {
      return await this.#geocoderClient.getPlacePredictions(new PlacePredictionsRequestViewModel({ sessionToken, countries: [], allowInternational: false, ...request }));
   }
   async getPlaceDetails(palceId: string) {
      const result = await this.#geocoderClient.getPlaceDetails(palceId, sessionToken);
      sessionToken = Guid.NewGuid();
      return result;
   }
}

function usePlaceGeocoder() {
   const geocoderClient = useApiClient(GeocoderClient);
   const [geocoder] = useState(() => new PlaceGeocoder(geocoderClient));
   return geocoder;
}

export default usePlaceGeocoder;